module.exports = __webpack_public_path__ + "static/media/1-2.f2514641.mp3";